var scrollDetectorInit;

(function ($) {

	const selectors = {
		element: '[data-detect-scroll]',
	}

	scrollDetectorInit = function () {
		$(selectors.element).each((i, el) => {
			new ScrollDetector(el);
		});
	}

	class ScrollDetector {
		constructor(element) {

			this.$element = $(element);
			if (this.$element.length) {
				this.init();
				this.resize();
				this.bind();
				this.scroll();
			}
		}

		init() {
			this.inView = false;
		}

		resize() {
			this.offY = this.$element.offset().top;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}


		scroll() {

			var scroll = window.scrollY;

			if (scroll + $(window).outerHeight() > this.offY && !this.inView) {
				this.inView = true;
				this.$element.trigger('scrolled-into-view');
			}
			if (scroll + $(window).outerHeight() < this.offY && this.inView) {
				this.inView = false;
				this.$element.trigger('scrolled-out-of-view');
			}

		}

	}

})(jQuery);

export default scrollDetectorInit;